import React from 'react';
import RegisterAbsenceTemplate from '../../components/register-absence-template';

const RegisterAbsence = () => (
  <RegisterAbsenceTemplate registrationType="registerAbsence" />
);

export default RegisterAbsence;
